import script from "./CollectionFilterResults.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterResults.vue?vue&type=script&setup=true&lang=js"

import "./CollectionFilterResults.vue?vue&type=style&index=0&id=07df717e&lang=scss"

const __exports__ = script;

export default __exports__